/**
 * Gathers base properties from the browser or server request context.
 *
 * @param {string} browser Browser name (Chrome, Firefox, etc)
 * @param {string} os Operating system the browser is running on (OS X, Windows, etc)
 * @param {string} locale Supported locale from the event configuration. Fallback to `en-US`.
 * @param {string} eventId ID for the event being accessed
 * @param {string} attendeeId ID of the logged in attendee
 * @param {string} environment Current environment (S606, T2, etc)
 * @param {string} accountMappingId Mapping ID for the account the event is under
 */
import { browserName, osName, isTablet, isMobileOnly } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';
import { getLocalStorage, setLocalStorage } from '@tools/localStorageUtilities';
import { DEVICE_ID_LOCAL_STORAGE } from './constants';

/**
 * Get analytics base properties from browser
 */
export const getBrowserProperties = () => {
  if (typeof window !== 'undefined') {
    return {
      browser: browserName,
      os: osName
    };
  }
};

export const getDeviceProperties = () => {
  if (typeof window !== 'undefined') {
    let deviceId = getLocalStorage(DEVICE_ID_LOCAL_STORAGE);
    if (!deviceId) {
      deviceId = `CA1.${uuidv4()}`;
      setLocalStorage(DEVICE_ID_LOCAL_STORAGE, deviceId, { skipJsonStringify: true });
    }

    let deviceType;
    if (isMobileOnly) {
      deviceType = 'mobile';
    } else if (isTablet) {
      deviceType = 'tablet';
    } else {
      deviceType = 'desktop';
    }

    return { deviceId, deviceType };
  }
};
